import { render, staticRenderFns } from "./LoadingSmall.vue?vue&type=template&id=2fe720f4&scoped=true&"
import script from "./LoadingSmall.vue?vue&type=script&lang=js&"
export * from "./LoadingSmall.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSmall.vue?vue&type=style&index=0&id=2fe720f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe720f4",
  null
  
)

export default component.exports